import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import type { LatLngExpression } from 'leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

const DefaultIcon = L.icon({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

interface MapViewProps {
  latitude?: number;
  longitude?: number;
  zoom?: number;
  height?: number | string;
  width?: number | string;
  emptyText?: string;
  popupContent?: React.ReactNode;
  scrollWheelZoom?: boolean;
  className?: string;
}

const MapView: React.FC<MapViewProps> = ({
  latitude,
  longitude,
  zoom = 15,
  height = 400,
  width = '100%',
  emptyText = 'Location is not available.',
  popupContent,
  scrollWheelZoom = false,
  className = '',
}) => {
  const hasValidCoordinates = Number.isFinite(latitude) && Number.isFinite(longitude);

  if (!hasValidCoordinates) {
    return (
      <div
        style={{ height, width }}
        className={`flex items-center justify-center rounded border border-gray-200 text-sm text-gray-600 ${className}`.trim()}>
        {emptyText}
      </div>
    );
  }

  const position: LatLngExpression = [latitude as number, longitude as number];

  return (
    <div style={{ height, width }} className={className}>
      <MapContainer center={position} zoom={zoom} scrollWheelZoom={scrollWheelZoom} style={{ height: '100%', width: '100%' }}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker position={position}>
          <Popup>
            {popupContent || (
              <>
                Latitude: {Array.isArray(position) && position[0]}
                <br />
                Longitude: {Array.isArray(position) && position[1]}
              </>
            )}
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default MapView;
